import { useState } from "react";

const AccountDetailsTab = ({data,validation,onSave,onBack, username})=>{

    const [form, setForm] = useState({
      username: username || "",
      password: data.password || "",
      confirmPassword: data.confirmPassword || "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (field) => (e) => {
        setForm((s) => ({ ...s, [field]: e.target.value }));
        setErrors((err) => ({ ...err, [field]: "" }));
    };

    const validate = () => {
        const err = {};
        if (!form.password.trim()) err.password = "Password is required.";
        else if (form.password.trim().length < 8) err.password = "Password must be at least 8 characters long.";
        if (!form.confirmPassword.trim()) err.confirmPassword = "Confirm password is required.";
        if (form.password !== form.confirmPassword) err.confirmPassword = "Passwords do not match.";
        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleSubmit = (e) => {
      e?.preventDefault();
      if (!validate()) return;
      
      onSave("accountDetails", form, "isAccountDetailsValid", true, 'business-details');
    };
    
    return(
      <form onSubmit={handleSubmit} className="w-full mx-auto bg-white dark:bg-gray-900 rounded-xl shadow-lg p-6 space-y-6">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">Login Credentials</h2>
        <p className="text-sm text-gray-600 dark:text-gray-300">Setup your login credentials. You can edit these later.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Username</label>
            <input
              type="text"
              value={form.username}
              className={`w-full rounded-md border px-3 py-2 text-sm  dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 bg-gray-100`}
              placeholder="username"
              readOnly={true}
            />
            {errors.firstName && <p id="firstName-error" className="mt-1 text-sm text-red-600">{errors.firstName}</p>}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Password</label>
            <input
              type="password"
              value={form.password}
              onChange={handleChange("password")}
              aria-invalid={!!errors.password}
              aria-describedby={errors.password ? "password-error" : undefined}
              className={`w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 ${errors.password ? "border-red-500" : "border-gray-300 dark:border-gray-700"}`}
              placeholder="Enter your password"
            />
            {errors.password && <p id="password-error" className="mt-1 text-sm text-red-600">{errors.password}</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Confirm Password</label>
            <input
              type="password"
              value={form.confirmPassword}
              onChange={handleChange("confirmPassword")}
              aria-invalid={!!errors.confirmPassword}
              aria-describedby={errors.confirmPassword ? "confirmPassword-error" : undefined}
              className={`w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 ${errors.confirmPassword ? "border-red-500" : "border-gray-300 dark:border-gray-700"}`}
              placeholder="Confirm your password  "
            />
            {errors.confirmPassword && <p id="confirmPassword-error" className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>}
          </div>
        </div>

        <div className="flex items-center justify-between gap-3">
          <button
            type="button"
            onClick={() => onBack()}
            className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-800 dark:text-gray-200 transition"
          >
            Back
          </button>

          <button
            type="submit"
            className="px-4 py-2 rounded-md bg-primary text-white hover:bg-primary/90 transition"
          >
            Next
          </button>
        </div>
      </form>
    )
};

export default AccountDetailsTab;